<template>
  <div>
    <div class="box-content" :class="user.grant.praticiens.create == true || user.grant.praticiens.update == true ? 'box-content' : 'box-content-active'" v-if="user.grant.praticiens.list == true || user.grant.praticiens.create == true || user.grant.praticiens.update == true || user.grant.specialities.delete == true">
      <div v-if="user.grant.praticiens.create == true || user.grant.praticiens.update == true" class="box-add">
        <h5>{{ current && current.id ? 'Modifier un praticien' : 'Ajouter un praticien' }}</h5>
        <div>
          <vs-input class="mt-5 w-full"
              autocomplete="off"
              label="Nom complet" v-model="form.name"
              :danger="errors.name ? true : false"
              :danger-text="errors.name ? errors.name[0] : ''"/>
        </div>
        <div>
          <vs-input class="w-full"
              autocomplete="off"
              label="Téléphone" v-model="form.phone"
              :danger="errors.phone ? true : false"
              :danger-text="errors.phone ? errors.phone[0] : ''"
              type="number" />
        </div>
        <div class="mt-5">
          <vs-button @click="current && current.id ? updateContent() : saveContent()" class="mr-6">Soumettre</vs-button>
          <vs-button v-if="current && current.id" @click="cancelData" type="border" color="danger">Annuler</vs-button>
        </div>
      </div>
      <div class="box-list" v-if="user.grant.praticiens.list == true || user.grant.praticiens.update == true">
        <vs-table
          ref="table"
          :max-items="10"
          :data="users"
        >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <h5>Liste des praticiens</h5>
            <div class="con-input-search vs-table--search">
              <input @keyup.enter="getSearch()" v-model="model.search" type="text" class="input-search vs-table--search-input">
              <i class="vs-icon notranslate icon-scale material-icons null">search</i>
            </div>
          </div>

          <template slot="thead">
            <vs-th>Nom & Prénoms</vs-th>
            <vs-th>Téléphone</vs-th>
            <vs-th>Créé le</vs-th>
            <vs-th v-if="user.grant.praticiens.update == true || user.grant.praticiens.delete == true">Actions</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ tr.name }}</vs-td>
              <vs-td>{{ tr.phone }}</vs-td>
              <vs-td>{{ parseDate(tr.created_at) }}</vs-td>
              <vs-td class="whitespace-no-wrap" v-if="user.grant.praticiens.update == true || user.grant.praticiens.delete == true">
                <div class="flex">
                  <vx-tooltip text="Modifier">
                    <feather-icon v-if="user.grant.praticiens.update == true" style="cursor:pointer" @click="edit(tr)"
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      class="mr-2"
                    />
                  </vx-tooltip>
                  <vx-tooltip text="Supprimer">
                    <feather-icon v-if="user.grant.praticiens.delete == true" style="cursor:pointer" @click="deleteUser(tr)"
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      class="mr-2"
                    />
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
            </tbody>
          </template>
        </vs-table>
        <vs-pagination v-if="last_page && model.page" :total="last_page" v-model="model.page"></vs-pagination>
      </div>
    </div>
    <div v-else>
      <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="@/assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full">
            <h1 class="sm:mx-0 mx-4 mb-12 text-3xl d-theme-heading-color">404 - Page introuvable!</h1>
            <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-heading-color">La page que vous demandez est introuvable</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _buildQuery } from '../../helper/helper'
import moment from 'moment'
const default_form = {
  name: '',
  phone: ''
}
export default {
  watch: {
    'model.page': function() {
      this.loadUsers();
    }
  },
  data: () => ({
    users: [],
    last_page: null,
    model:{
      page: 1,
      search: ''
    },
    current: {},
    form:{
      name: '',
      phone: ''
    },
    errors: [],
    user: {}
  }),
  created(){
    this.user = JSON.parse(localStorage.getItem('user_cnhu'))
  },
  mounted(){
    if (this.user.grant.praticiens.list == true || this.user.grant.praticiens.update == true || this.user.grant.praticiens.delete == true){
      this.loadUsers()
    }
  },
  methods:{
    saveContent(){
      if (this.user.grant.praticiens.create){
        this.$vs.loading()
        this.$http.post('praticiens/create',
          this.form
        ).then((re) => {
        if (re.data.status){
          this.users.unshift(re.data.model)
          this.form = { ...default_form }
          this.errors = []
          this.$vs.notify({
          time: 5000,
          title: 'Succès!',
          text: "Opération effectuée avec succès",
          color: 'success',
          iconPack: 'feather',
          position: 'top-right',
          icon: 'icon-check-circle'
        })
        }
        this.$vs.loading.close()
      }).catch((error) => {
        this.$vs.loading.close()
        if (error.response.status === 401) {
          this.$vs.notify({
            title: 'Erreur',
            text: 'Votre session a expiré',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-check',
            position: 'top-right'
          })
          this.$router.push({name: "page-login"})
        }else{
          this.errors = error.response.data.errors
        }
      })
      }else{
        this.$vs.notify({
          title: 'Erreur',
          text: 'Vous n\'avez pas les autorisations requises',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-check',
          position: 'top-right'
        })
      }
    },
    cancelData(){
      this.current = {}
      this.form = { ...default_form }
      this.errors = []
    },
    updateContent(){
      this.$vs.loading()
        this.$http.post('praticiens/update',
          this.form
        ).then((re) => {
        if (re.data.status){
          let index = this.users.indexOf(this.current)
          this.users.splice(index, 1, re.data.model)
          this.cancelData()
          this.$vs.notify({
          time: 5000,
          title: 'Succès!',
          text: "Opération effectuée avec succès",
          color: 'success',
          iconPack: 'feather',
          position: 'top-right',
          icon: 'icon-check-circle'
        })
        }
        this.$vs.loading.close()
      }).catch((error) => {
        this.$vs.loading.close()
        if (error.response.status === 401) {
          this.$vs.notify({
            title: 'Erreur',
            text: 'Votre session a expiré',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-check',
            position: 'top-right'
          })
          this.$router.push({name: "page-login"})
        }else{
          this.errors = error.response.data.errors
        }
      })
    },
    deleteUser(tr){
      if (confirm('Voulez-vous supprimer ?')){
        this.$vs.loading()
        this.$http.post('praticiens/delete',
          {id: tr.id}
        ).then((re) => {
          if (re.data.status){
            let index = this.users.indexOf(tr)
            this.users.splice(index, 1)
            this.$vs.notify({
            time: 5000,
            title: 'Succès!',
            text: "Opération effectuée avec succès",
            color: 'success',
            iconPack: 'feather',
            position: 'top-right',
            icon: 'icon-check-circle'
          })
          }
          this.$vs.loading.close()
        }).catch((error) => {
          this.$vs.loading.close()
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "page-login"})
          }
        })
      }
    },
    edit(element){
      this.current = element
      this.form = { ...element }
    },
    getSearch(){
      if (this.model.search != ''){
        this.model.page = 1
        this.loadUsers()
      }
    },
    parseDate(date){
      return moment(date).format('DD-MM-YYYY H:mm')
    },
    loadUsers() {
      this.$vs.loading()
      this.$http.get('praticiens'+_buildQuery(this.model)).then((response) => {
        this.users = response.data.data
        this.last_page = response.data.last_page
        this.$vs.loading.close()
      }).catch((error) => {
        this.$vs.loading.close()
        if (error.response.status === 401) {
          this.$vs.notify({
            title: 'Erreur',
            text: 'Votre session a expiré',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-check',
            position: 'top-right'
          })
          this.$router.push({name: "page-login"})
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .box-content{
    display: grid;
    grid-template-columns: 2fr 3fr;
    grid-gap: 20px;
    .box-add{
      background-color: #fff;
      padding: 20px;
      height: 250px;
      max-height: 250px;
      border-radius: 10px;
    }
    .box-list{
      background-color: #fff;
      padding: 20px;
      min-height: 250px;
      height: auto;
      border-radius: 10px;
    }
  }
  .box-content-active{
    display: grid;
    grid-template-columns: 1fr;
    .box-add{
      background-color: #fff;
      padding: 20px;
      height: 350px;
      max-height: 350px;
      border-radius: 10px;
    }
    .box-list{
      background-color: #fff;
      padding: 20px;
      min-height: 250px;
      height: auto;
      border-radius: 10px;
    }
  }
  @media only screen and (max-width: 830px){
    .box-content{
      display: grid !important;
      grid-template-columns: 1fr !important;
      grid-gap: 20px;
      .box-add{
        background-color: #fff;
        padding: 20px;
        min-height: 100px;
        height: auto;
        border-radius: 10px;
      }
      .box-list{
        background-color: #fff;
        padding: 20px;
        min-height: 100px;
        height: auto;
        border-radius: 10px;
      }
    }
  }
</style>
